/**
 * Collection of design tokens that dictate the intensity and visual presence of shadows, providing
 * a sense of depth in user interfaces.
 */ const shadows = {
    none: {
        size: 0,
        blur: 0,
        spread: 0,
        opacity: 0
    },
    weaker: {
        size: 1,
        blur: 2,
        spread: 0,
        opacity: 0.25
    },
    weak: {
        size: 1,
        blur: 2,
        spread: 1,
        opacity: 0.25
    },
    medium: {
        size: 2,
        blur: 3,
        spread: 1,
        opacity: 0.25
    },
    strong: {
        size: 4,
        blur: 6,
        spread: 1,
        opacity: 0.25
    },
    stronger: {
        size: 6,
        blur: 8,
        spread: 1,
        opacity: 0.25
    }
};

export { shadows };
//# sourceMappingURL=shadows.js.map
